module.exports = __webpack_public_path__ + "img/jiaoyu.56d4b991.png";